/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_CategoriesInputs */

const vi_shop_group_categories = /** @type {(inputs: Shop_Group_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục bán`)
};

/**

* @param {Shop_Group_CategoriesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_categories = /** @type {((inputs?: Shop_Group_CategoriesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_CategoriesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_categories(inputs)
});